"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamPanelMeta = exports.TeamPanelMetaDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var lodash_1 = require("lodash");
var ui_1 = require("@shapeable/ui");
var entity_link_value_1 = require("./entity-link-value");
var cls = (0, utils_1.classNames)('team-panel-meta');
exports.TeamPanelMetaDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var TeamStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var NoResultMessageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Team: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), TeamStyles),
  NoResultMessage: styled_components_1.default.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), NoResultMessageStyles)
};
var TeamPanelMeta = function (props) {
  var className = props.className,
    children = props.children,
    _a = props.items,
    items = _a === void 0 ? [] : _a;
  var t = (0, ui_1.useLang)();
  var hasItems = !!items.length;
  var sortedItems = (0, lodash_1.sortBy)(items, 'status.name');
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, !hasItems && react_1.default.createElement(My.NoResultMessage, null, t('No Collaborations Found')), hasItems && sortedItems.map(function (item) {
    var _a;
    return react_1.default.createElement(My.Team, {
      key: item.id,
      variant: 'small',
      badge: (_a = item === null || item === void 0 ? void 0 : item.status) === null || _a === void 0 ? void 0 : _a.name,
      entity: item
    });
  }), children);
};
exports.TeamPanelMeta = TeamPanelMeta;
exports.TeamPanelMeta.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;